import Alpine from 'alpinejs'

const data = (params = {}) => ({
  /**
   *  Data
   */
  items: [],
  enableDestroyField: true,
  limit: 1000,
  currentIndex: 0,
  currentIndexAtOnce: 0,
  replaceIndexKey: '{{ indexKey }}',

  /**
   *  Targets
   */

  targets: {
    node: {
      ['x-init']: 'items.push({ index: currentIndex, dom: $el, positionField: null, destroyField: null, positionLabel: null }); currentIndex++'
    },
    positionLabel: {
      ['x-init']: 'items[items.length - 1].positionLabel = $el; $el.innerHTML = items.length',
    },
    positionField: {
      ['x-init']: 'items[items.length - 1].positionField = $el; $el.value = items.length',
      ['@change']: 'resetPositions'
    },
    destroyField: {
      ['x-init']: 'items[items.length - 1].destroyField = $el; checkAlreadyMarkDestroy(items[items.length - 1])'
    },
    copiedTemplate: {
      ['x-ref']: 'copiedTemplate'
    },
    sortingPanel: {
      ['x-ref']: 'sortingPanel',
    },
    willDestroyItems: {
      ['x-ref']: 'willDestroyItems'
    }
  },

  /**
   *  Main & Event Callback
   */

  init() {
  },

  isNodeEmpty(node) {
    const fields = node.querySelectorAll('input, select')
  
    return Array.from(fields)
      .filter(el => el.type !== 'hidden' && el.type !== 'checkbox')
      .every(el => {
        if (el.tagName === 'SELECT') {
          return !el.value || el.value.trim() === ''
        }
        return !el.value || el.value.trim() === ''
      })
  },

  resetPositions(fromEvent = true) {
    if ( fromEvent ) {
      const oldIndex = this.items.findIndex( ({ positionField }) => positionField.isSameNode(this.$event.currentTarget) )
      const targetItem = this.items.splice(oldIndex, 1)[0]
      const newIndex = parseInt(targetItem.positionField.value) - 1
      this.items.splice(newIndex, 0, targetItem)
    }

    this.disableRedactors(this.items.map( ({dom}) => dom))

    this.items.forEach( ({ dom, positionField }, idx) => {
      positionField.value = idx + 1 // 重設position的value
      const positionResetEvent = new CustomEvent('position:reset')
      positionField.dispatchEvent(positionResetEvent)
      if ( idx === 0 ) { return }

      this.items[idx - 1].dom.insertAdjacentElement('afterend', dom)
    })

    this.enableRedactors(this.items.map( ({dom}) => dom))
  },

  /**
   *  Public Function
   */

  showPlusButton() {
    const dom = this.$el.closest(`[x-bind='targets.node']`)
    return (this.items.findIndex(item => item.dom.isSameNode(dom)) === this.items.length - 1) && this.items.length < this.limit
  },

  showMinusButton() {
    return this.items.length > 0
  },

  addNode() {
    if (this.items.length < this.limit) {
      const html = this.$refs.copiedTemplate.innerHTML.replaceAll(this.replaceIndexKey, this.currentIndex)
      this.$refs.sortingPanel.insertAdjacentHTML('beforeend', html)
    }
  },

  adjustMultipleNodesAtOnce(count) {
    // always refresh node list
    this.nodes = this.$refs.sortingPanel.querySelectorAll('[x-bind="targets.node"]')

    // Add Node Steps
    if (this.nodes.length < count) {
      const times = count - this.nodes.length
      for (let i = 0; i < times; i++) {
        const index = this.currentIndexAtOnce + i + count
        const html = this.$refs.copiedTemplate.innerHTML.replaceAll(this.replaceIndexKey, index)
        this.$refs.sortingPanel.insertAdjacentHTML('beforeend', html)
      }
      this.currentIndexAtOnce  = this.currentIndexAtOnce + times

      return
    }

    // Delete Node Steps
    // 1. Cleanup: remove extra nodes from the end
    let excess = this.nodes.length - count

    // Step 1: 先刪「空節點」，只刪超額數量
    if (excess > 0) {
      Array.from(this.nodes).reverse().forEach(node => {
        if (excess <= 0) return
        if (this.isNodeEmpty(node)) {
          this.items = this.items.filter(item => !item.dom.isSameNode(node))
          node.remove()
          excess--
        }
      })
    }

    // Step 2: 如果還有多，就刪「有資料節點」
    if (excess > 0) {
      this.nodes = this.$refs.sortingPanel.querySelectorAll('[x-bind="targets.node"]')
      Array.from(this.nodes).reverse().forEach(node => {
        if (excess <= 0) return
        // 不判斷空了，強制刪
        this.items = this.items.filter(item => !item.dom.isSameNode(node))
        node.remove()
        excess--
      })
    }
  
    // refresh node list
    this.nodes = this.$refs.sortingPanel.querySelectorAll('[x-bind="targets.node"]')
    
    // 3. Reindex position fields
    this.nodes.forEach((node, idx) => {
      const positionField = node.querySelector('[x-bind="targets.positionField"]')
      if (positionField) {
        positionField.value = idx + 1
        positionField.dispatchEvent(new Event('change')) // update Alpine if using @change
      }
    })
  },
  
  removeNode({target}) {
    const targetNode = target.closest(`[x-bind='targets.node']`)
    if (this.enableDestroyField) {
      this.moveToWillDestroy(targetNode)
    } else {
      // NOTICE: 這邊先呼叫一次後，再執行addNodeWhenNoItems，才不會變成undefined，導致壞掉，
      //         可能是因為dom被delete，造成影響到$refs
      this.$refs.sortingPanel
      targetNode.remove()
      this.items = this.items.filter(item => !item.dom.isSameNode(targetNode))
    }
    this.resetPositions(false)
  },
  /**
   *  Value Changed
   */

  /**
   *  Private Function
   */

  moveToWillDestroy(targetNode) {
    this.disableRedactors([targetNode])
    const item = this.items.find(item => item.dom.isSameNode(targetNode))
    item.destroyField.value = '1'
    item.positionField.type = 'hidden'
    this.items = this.items.filter(item => !item.dom.isSameNode(targetNode))
    this.$refs.willDestroyItems.insertAdjacentElement('beforeend', targetNode)
  },

  async checkAlreadyMarkDestroy(item) {
    if (!['true', '1'].includes(item.destroyField.value)) {
      return
    }

    await this.$nextTick()
    this.removeNode({target: item.destroyField})
  },

  disableRedactors(doms) {
    // NOTICE: 避免sort中途，redactor直接觸發disconnect
    doms.forEach(dom => {
      [...dom.querySelectorAll('[data-controller="redactor"]')].forEach(redactor => {
        redactor.setAttribute('data-redactor-destroy-on-disconnect-value', 'false')
        redactor.setAttribute('data-redactor-enabled-value', 'false')
      })
    })
  },

  enableRedactors(doms) {
    // NOTICE: sort結束後，可以正常使用redactor觸發disconnect
    doms.forEach( dom => {
      [...dom.querySelectorAll('[data-controller="redactor"]')].forEach(redactor => {
        setTimeout(() => {
          redactor.setAttribute('data-redactor-destroy-on-disconnect-value', 'true')
          redactor.setAttribute('data-redactor-enabled-value', 'true')
        }, 200)
      })
    })
  },

  ...params
})

Alpine.data('AdminFormCopyHtml', data)
export default data
